import { useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import { CustomCardHeader } from '../../common/custom-card-header/CustomCardHeader';
import './shippingAddress.scss';
import { ShippingAddressEdit } from './shippingAddressEdit/ShippingAddressEdit';
import { useUserContext } from '../../../context/UserContext';

const ShippingAddressDetailsReadOnly = ({ userDetails, shippingAddress }) => (
  <div className='ship-add-details-wrapper' style={{ color: '#2E2B2B' }}>
    <div className={'label-text'}>
      {userDetails?.first_name ?? ''} {userDetails?.last_name ?? ''}
    </div>
    <div className={'label-text'}>{`${shippingAddress?.address ?? ''}${
      shippingAddress?.shipping_address &&
      shippingAddress?.shipping_address !== ''
        ? ', '
        : ''
    }`}</div>
    {shippingAddress?.shipping_address &&
    shippingAddress?.shipping_address !== '' ? (
      <div className={'label-text'}>{`${shippingAddress?.shipping_address}, `}</div>
    ) : null}

    <div className={'label-text'}>
      {shippingAddress?.state ? `${shippingAddress.state},` : ''}{' '}
      {shippingAddress?.city ?? ''} {shippingAddress?.zipcode ?? ''}
    </div>
  </div>
);

const SHIPPING_ADDRESS_UPDATE = 'shippping_address_update';
export const ShippingAddress = ({
  updatingParts,
  shippingAddress,
  handleDataChange,
  handleCancelUpdate,
  isSM,
}) => {
  const [isEditingMode, setIsEditingMode] = useState(false);
  const { user } = useUserContext();

  const handleShippingAddressUpdate = async (newValues) => {
    let payload = {
      shipping_address: {
        ...shippingAddress,
        ...newValues,
      },
    };
    handleDataChange(SHIPPING_ADDRESS_UPDATE, payload, () => {
      setIsEditingMode(false);
    });
  };
  return (
    <Card
      className='no-shadow profile-about-me-wrapper'
      style={{
        border: `1px solid #2E2B2B`,
        backgroundColor: 'transparent',
        marginRight: isSM ? 12 : 0,
        marginLeft: isSM ? 12 : 0,
      }}
    >
      <CustomCardHeader
        title='Shipping Address'
        actionBtnLabel={isEditingMode ? 'Close' : 'Edit'}
        handleActionBtnClick={(e) => {
          setIsEditingMode(!isEditingMode);
          handleCancelUpdate(SHIPPING_ADDRESS_UPDATE);
        }}
      />
      <CardBody>
        {isEditingMode ? (
          <ShippingAddressEdit
            shippingAddress={shippingAddress}
            onSubmit={handleShippingAddressUpdate}
            isUpdating={updatingParts[SHIPPING_ADDRESS_UPDATE]}
          />
        ) : (
          <ShippingAddressDetailsReadOnly
            userDetails={user}
            shippingAddress={shippingAddress}
          />
        )}
      </CardBody>
    </Card>
  );
};
